import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { BUILD_HASH } from '../build-info';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  private http = inject(HttpClient);

  getTranslation(langPath: string) {
    // langPath is either '<lang>' (root scope) or '<scope>/<lang>' (feature scope).
    // Cache-bust with BUILD_HASH because Angular CLI does not content-hash assets/.
    return this.http.get<Translation>(`/assets/i18n/${langPath}.json?v=${BUILD_HASH}`);
  }
}
